import { render, staticRenderFns } from "./ElementsTemplatePage.vue?vue&type=template&id=ed7976f0&scoped=true&"
import script from "./ElementsTemplatePage.vue?vue&type=script&lang=js&"
export * from "./ElementsTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./ElementsTemplatePage.vue?vue&type=style&index=0&id=ed7976f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7976f0",
  null
  
)

export default component.exports